import React from 'react';
import PropTypes from 'prop-types';
import { MAIN_COLOR } from '../../../styles/variables';

const AddIcon = ({ color, width, height }) => {
  return (
    <svg
      className="icon-add"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      viewBox="0 0 30 31"
    >
      <defs>
        <path
          id="add-icon"
          d="M16 14h6a1 1 0 0 1 0 2h-6v6a1 1 0 0 1-2 0v-6H8a1 1 0 0 1 0-2h6V8a1 1 0 0 1 2 0v6zm-1 14c7.18 0 13-5.82 13-13S22.18 2 15 2 2 7.82 2 15s5.82 13 13 13zm0 2C6.716 30 0 23.284 0 15 0 6.716 6.716 0 15 0c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15z"
        />
      </defs>
      <g fill="none" fillRule="evenodd" transform="translate(0 .5)">
        <mask id="add-iconb" fill="#fff">
          <use xlinkHref="#add-icon" />
        </mask>
        <use fill="#979797" fillRule="nonzero" xlinkHref="#add-icon" />
        <g fill={color} mask="url(#add-iconb)">
          <path d="M0 0h30v30H0z" />
        </g>
      </g>
    </svg>
  );
};

AddIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};

AddIcon.defaultProps = {
  color: MAIN_COLOR,
  width: '30px',
  height: '30px',
};

export default AddIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/AddIcon/index.js